import { render, staticRenderFns } from "./DtitButton.vue?vue&type=template&id=1f3a3f30&scoped=true&"
import script from "./DtitButton.vue?vue&type=script&lang=js&"
export * from "./DtitButton.vue?vue&type=script&lang=js&"
import style0 from "./DtitButton.vue?vue&type=style&index=0&id=1f3a3f30&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a3f30",
  null
  
)

export default component.exports